<template>
  <div class="base-button-octagon">
    <div class="container">
      <svg class="octagon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 101">
        <polygon points="71.211 0.5 29.789 0.5 0.5 29.789 0.5 71.211 29.789 100.5 71.211 100.5 100.5 71.211 100.5 29.789 71.211 0.5" fill="none" stroke="#fff" stroke-miterlimit="10"/>
      </svg>
      <div class="text-container">
         <BaseText9 class="text" :text="text"/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseText9 from '@/components/BaseText9/BaseText9'
export default {
  components: {
    BaseText9
  },
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button-octagon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.container {
  position: relative;
  font-size: 3rem;
  width: 3em;
}
.octagon {
  width: 100%;
  display: block;
}
.text-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
